import React from "react"

import { CustomTraceConfig } from "@/metrics/registry/configuration"
import { resolveCustomTraceUnit } from "@/metrics/registry/configuration/utils/traceConstants"

import type { MetricRecordData } from "@/types/metrics/contracts"

import { NumericalMetricRecord } from "../base/NumericalMetricRecord"

export class CustomTraceMetricRecord extends NumericalMetricRecord {
  private static readonly METRIC_TYPE_LABEL = "Custom Trace Metric"

  renderEditorMetadata(
    metricRecordData: MetricRecordData,
    onChange: (metric: MetricRecordData) => void,
    _textAreaRef?: React.RefObject<HTMLTextAreaElement>,
    editorContext?: { selectedAgentIds?: string[] },
  ): React.ReactNode {
    return (
      <CustomTraceConfig
        metricRecordData={metricRecordData}
        onChange={onChange}
        selectedAgentIds={editorContext?.selectedAgentIds}
      />
    )
  }

  renderMetricType(): React.ReactNode {
    return CustomTraceMetricRecord.METRIC_TYPE_LABEL
  }

  renderMetadataField(metricRecordData: MetricRecordData): React.ReactNode {
    return (
      <div className="flex flex-col gap-2">
        <div>
          <h3 className="font-semibold">Span Name: </h3>
          <p>{metricRecordData.metric_metadata?.span_name}</p>
        </div>
        <div>
          <h3 className="font-semibold">Metric Attribute: </h3>
          <p>
            {metricRecordData.metric_metadata?.value_source === "duration"
              ? "Span duration"
              : metricRecordData.metric_metadata?.metric_attribute}
          </p>
        </div>
        <div>
          <h3 className="font-semibold">Aggregation Method: </h3>
          <p>{metricRecordData.metric_metadata?.aggregation_method}</p>
        </div>
        <div>
          <h3 className="font-semibold">Unit: </h3>
          <p>
            {resolveCustomTraceUnit(metricRecordData.metric_metadata ?? {})}
          </p>
        </div>
      </div>
    )
  }
}
